import type { BasketPricingType, ItemType } from "@shared/graphql.types";

import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useCurrencySymbol } from "hooks";
import { getPrice } from "utils/getPrice";
import { useIsKitMembership } from "components/Basket/hooks/useIsKitMembership";
import {
  PriceText,
  PricingContainer,
  PriceDiscountText
} from "components/BasketLists/MembershipList/MembershipList.styles";

interface Props {
  item: ItemType;
  pricing: BasketPricingType;
  isCheckout?: boolean;
}

export const MembershipPricing: React.FC<Props> = ({
  item,
  isCheckout,
  pricing: {
    totalMembershipDiscountedPrice,
    totalMembershipPrice,
    totalDiscountsByType
  }
}) => {
  const currencySymbol = useCurrencySymbol();
  const itemPrice = item?.membership?.price || totalMembershipPrice;
  const hasMembershipDiscount = totalMembershipDiscountedPrice !== itemPrice;
  const itemIsFree = totalMembershipDiscountedPrice === 0;
  const isKitMembership = useIsKitMembership(totalDiscountsByType);

  return (
    <PricingContainer {...(isCheckout && { alignItems: "flex-end" })}>
      <Box marginLeft="auto" justifyContent="right">
        {itemIsFree ? (
          <Text mt={0} variant="demi0" textTransform="uppercase">
            {isKitMembership ? "included" : "free"}
          </Text>
        ) : (
          <>
            <PriceText
              variant="book1"
              textDecoration={hasMembershipDiscount ? "line-through" : "none"}
            >
              {getPrice(itemPrice, currencySymbol)}
            </PriceText>
            {hasMembershipDiscount && (
              <PriceDiscountText
                variant="demi0"
                data-testid="primary-price-discount"
              >
                {getPrice(totalMembershipDiscountedPrice, currencySymbol)}
              </PriceDiscountText>
            )}
          </>
        )}
      </Box>
    </PricingContainer>
  );
};
